// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../format/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatWithOptions = convertToFP(fn, 3);
export default formatWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatWithOptions/index.js
// module id = 887
// module chunks = 0